export function calculateGovernancePosture({
  criticalRisks = 0,
  delayedInitiatives = 0,
  avgMitigationProgress = 0,
  mttr = null,
  appetiteBreached = false,
  correlationStressImpact = 0,
  topConcentration = 0,
  settings = {},
}) {

  let score = 0;

  const reasons = [];

  if (criticalRisks > 0) {
    score += Math.min(criticalRisks * 15, 30);

    reasons.push(
      `${criticalRisks} critical risks exceed tolerance.`
    );
  }

  if (
    delayedInitiatives >=
    Number(settings.delayedInitiativesThreshold || 5)
  ) {
    score += 25;

    reasons.push(
      "Delayed initiatives exceed configured threshold."
    );
  }

  if (avgMitigationProgress < 50) {
    score += 20;

    reasons.push(
      "Mitigation execution progress is below 50%."
    );
  }

  if (mttr && Number(mttr) > 8) {
    score += 15;

    reasons.push(
      "MTTR is above expected recovery threshold."
    );
  }

  if (appetiteBreached) {
    score += 30;
    reasons.push("Portfolio exposure exceeds configured risk appetite.");
  }

  if (Number(correlationStressImpact || 0) >= 15) {
    score += 20;
    reasons.push(
      "Shared dependency stress materially increases portfolio tail-risk."
    );
  }

  if (Number(topConcentration || 0) >= 25) {
    score += 15;
    reasons.push(
      "Portfolio exposure is concentrated in a single scenario or asset."
    );
  }

  score = Math.min(score, 100);

  if (score >= 80) {
    return {
      level: "Critical",
      tone: "red",
      score,
      narrative:
        "Immediate board-level attention is required.",
      reasons,
    };
  }

  if (score >= 55) {
    return {
      level: "High",
      tone: "red",
      score,
      narrative:
        "Executive attention is required to stabilize governance posture.",
      reasons,
    };
  }

  if (score >= 30) {
    return {
      level: "Elevated",
      tone: "amber",
      score,
      narrative:
        "Risk governance pressure is increasing across key indicators.",
      reasons,
    };
  }

  if (score >= 10) {
    return {
      level: "Moderate",
      tone: "blue",
      score,
      narrative:
        "Some governance indicators require monitoring.",
      reasons,
    };
  }

  return {
    level: "Stable",
    tone: "green",
    score,
    narrative:
      "Governance posture is operating within expected tolerance.",
    reasons: reasons.length
      ? reasons
      : ["No material governance issues detected."],
  };
}